import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Moment from 'react-moment';
import ReactHtmlParser from 'react-html-parser';
import { userGroupUrlCheck,getUserTimeZone } from '../../utils/userGroupUrlCheck';
import Toast from '../commons/helpers/toast';
import { clearAction } from '../../actions/commonActions'; 
import { listInvoiceAction, updateInvoiceAction, invoicePreviewAction, invoiceSendtoClientAction} from '../../actions/eventActions'; 
import { LIST_INVOICE_SUCCESS, UPDATE_INVOICE_SUCCESS } from '../../actions';
import * as staticConfigs from '../../configs/staticConfigs'; 
import { MSG_NOT_FOUND } from '../../configs/msgConfigs';
import { LBL_CN_NO,LBL_INVOICE_REGENERATED,LBL_EXPENSE,LBL_DISCOUNT,LBL_REMOVE,LBL_VOID_ON,LBL_CREATED_ON,LBL_REGEN_INVOICE,LBL_VOID_INVOICE,LBL_DESCRIPTION,LBL_TYPE,LBL_OE_DISCOUNT,LBL_ADD_NEW,LBL_AMOUNT,LBL_INVOICE_ID,LBL_CREATED_UPDATED_TIME,LBL_CREATED_TIME,LBL_SENT_TO_CUSTOMER } from '../../configs/labelConfigs';
import { Scrollbars } from 'react-custom-scrollbars';
import PreviewInvoice from '../event/previewInvoice';

import { converDateToLocal } from '../../utils/commonUtilities';

class InvoiceComponent extends Component { 
    scrollbars = React.createRef();
    constructor(props){
        super();

        this.state = {
            userGroupId: '', 
            toastMessage: '',
            toastFlag: false,
            toastSuccess: true,
            tableRows:[],       
            listInvoice:[],       
            formError:{}       
        }

        this.sendOldInvoice = this.sendOldInvoice.bind(this);

        this.previewQuote = React.createRef(); 
    }

    
    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:true});
    } 

    setToasterState = (isEnabled,message,isSucces,isAutoHide=true) => {
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToast();
            }, 3000);
        }    
    }

   

    componentDidMount() {
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined) userGroup = userGroupData.user_group;
    } 

    componentDidUpdate(prevProps) {  
        const { status, invoiceActivity} = this.props;

        if(invoiceActivity && invoiceActivity !== prevProps.invoiceActivity){
            let arrSendResp = invoiceActivity.split('~~');
            console.log(arrSendResp);  
            if(arrSendResp[0] === LIST_INVOICE_SUCCESS){
                this.setState({listInvoice:this.props.invoiceList});
                let{tableRows,formError} = this.state;
                tableRows = [];
                let key = 0;
                this.props.invoiceList.current_invoice.additions.map((item,index)=>{
                    
                    
                    tableRows.push({
                        key:key,   
                        type:item.amount<0?'discount':'expense',
                        description:item.name,
                        amount:item.amount<0?item.amount*-1:item.amount,
                        id:item.id
                    });
                    formError[key] = {description:'',amount:''}
                    key++;
                })
                this.setState({tableRows:tableRows,formError:formError});
            }else if(arrSendResp[0] === UPDATE_INVOICE_SUCCESS){
                // this.setToasterState(true,LBL_INVOICE_REGENERATED,true)
                this.props.invoiceSendtoClientAction(this.props.event_id);
                this.props.listInvoiceAction(this.props.event_id);
            }
        }  
    }
    sendOldInvoice(){
        this.props.invoiceSendtoClientAction(this.props.event_id);
    }
    addNewRow(e){
        let{tableRows,formError} = this.state;
        let key = 0;
        if(tableRows.length>0){
            key = tableRows[tableRows.length-1].key+1
        }
        tableRows.push({
            key:key,   
            type:'expense',
            description:'',
            amount:0.0,
            id:''
        });
        formError[key] = {description:'',amount:''}
        this.setState({tableRows:tableRows,formError:formError});
    }

    removeRow(e,key){
        let {tableRows} = this.state;
        let newRows = tableRows.filter(item => item.key!==key);
        console.log(newRows);
        this.setState({tableRows:newRows});
    }
    onHandleChange(e,key){
        let {tableRows,formError} = this.state;
        let value = e.target.value;
        const name = e.target.name.split('_')[0];
        tableRows.map((item,index)=>{
            if(item.key === key){
                if(name === 'amount' && isNaN(value)){
                    value = item.amount;
                }
                item[name] = value;
            }

        })
        if(formError[key][name] === 'input-error'){
            formError[key][name] = '';
        }
        this.setState({tableRows:tableRows,formError:formError});    

    }

    regenerateInvoice(){
        let {tableRows,formError} = this.state;

        let generate = true;
        tableRows.map((item,index)=>{
            if(Number(item.amount) === 0){
                formError[item.key].amount = 'input-error';
                generate = false;
            }else{
                formError[item.key].amount = '';
            }if(item.description.trim() === ''){
                formError[item.key].description = 'input-error';
                generate = false;
            }else{
                formError[item.key].description = '';
            }
            item.description = item.description.trim();
        })
        this.setState({tableRows:tableRows,formError:formError},()=>{
            if(generate){
                this.callPreviewQuote(this.props.event_id);
            }
        });
    }

    callPreviewQuote = (eventId) => {
        this.previewQuote.current.handleOpenModal();
        this.props.invoicePreviewAction(this.props.event_id);
    }
    saveFormData = () =>{
        let data = {
            event_id:this.props.event_id,
            additions:[]
        }
        this.state.tableRows.map((item,index)=>{
            if(item.id){
                data.additions.push(
                    {id:item.id,
                     name:item.description,
                     amount:item.type==='discount'?Number(item.amount)*-1:Number(item.amount)
                    }
                 )
            }else{
                data.additions.push(
                    {
                     name:item.description,
                     amount:item.type==='discount'?Number(item.amount)*-1:Number(item.amount)
                    }
                 )
            }
            
        })
        this.props.updateInvoiceAction(data);
    }
    showInvoicePreview = (url)=>{
        const link = document.createElement('a');
        link.href = url;
        link.download = 'download';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link)

    }
    onHandleBlur = (e,key) =>{
        let {tableRows} = this.state;
        let value = e.target.value;
        const name = e.target.name.split('_')[0];
        tableRows.map((item,index)=>{
            if(item.key === key){
                if(name === 'amount' && isNaN(value)){
                    value = item.amount;
                }
                item[name] = Number(value);
            }

        })
        this.setState({tableRows:tableRows});

    }

    handleFocus = (event) => event.target.select();

    render(){
        const { toastMessage,toastFlag,toastSuccess,hasMore,tableRows } = this.state; 
        const { status,invoiceQuote } = this.props;  

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        let profileCurrency = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
            profileCurrency = userGroupData.profile_currency;
        }

        if(status===401 || status===403){  
            if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP) {
                return <Redirect to={staticConfigs.ROUTE_AFFILIATE_REFRESH} />;
            }
            else if(userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP) {
                return <Redirect to={staticConfigs.ROUTE_REFRESH} />; 
            }
            else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP) {
                return <Redirect to={staticConfigs.ROUTE_CLIENT_REFRESH} />; 
            }
        }

        let timeZone =  getUserTimeZone(window.location);
        return( 
            <React.Fragment>
            <Toast toastDescription={this.state.toastMessage} toastFlag={this.state.toastFlag} toastSuccess={this.state.toastSuccess} closeToast={this.onCloseToast} />
                <div className="tab-container col-12">
                    <Scrollbars ref={this.scrollbars} style={{ "height": 'calc(80vh - 15vh)'}} autoHide renderThumbVertical={this.renderThumb} >
                        <div className="box-content">
                           <div className="table-responsive">
                              <table id="data-table" className="table" style={{width:"100%"}}>
                                  <thead>
                                      <tr>
                                          <th className="text-center">{LBL_INVOICE_ID}</th>
                                          <th className="text-center">{LBL_CREATED_UPDATED_TIME}</th>
                                          <th className="text-center">{LBL_AMOUNT} ({profileCurrency})</th>
                                          <th className="text-center">{LBL_SENT_TO_CUSTOMER}</th>
                                      </tr>
                                  </thead>                                    
                                  <tbody>
                                {this.state.listInvoice && !this.state.listInvoice.current_invoice &&
                                    <tr>
                                        <td colSpan="4" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }
                                {this.state.listInvoice && this.state.listInvoice.current_invoice && 
                                        <tr>
                                            <td className="text-center">
                                                <Link to="#" onClick={(e) => this.showInvoicePreview(this.state.listInvoice.current_invoice.invoice_file)}><b>{this.state.listInvoice.current_invoice.invoice_number}</b></Link>
                  
                                            </td>
                                            <td className="text-center">
                                                {converDateToLocal(this.state.listInvoice.current_invoice.created_on,"+00:00",'ddmmyyyyhhmm')}
                                            </td>
                                            <td className="text-center">
                                                {parseFloat(this.state.listInvoice.current_invoice.total).toFixed(2)}
                                            </td>
                                            <td className="text-center">
                                                {this.state.listInvoice.current_invoice.sent?'Y':'N'}
                                            </td>
                                        </tr> 

                                }   
                                  
                                    
                                          
                                    </tbody>
                                 </table>
                           </div>                            
                        </div>
                        {this.props.isAddEvent && this.props.isClientPage===false &&<div className="add-new-btn-div">
                            <label>{LBL_OE_DISCOUNT}</label>
                            <button type="button" className="btn btn-primary float-right" id="addNew" name="addNew" onClick={(e)=>this.addNewRow(e)} disabled={false}>{LBL_ADD_NEW}</button>
                        </div>}
                        {this.props.isClientPage===false && <div className="box-content">
                           <div className="table-responsive">
                              <table id="data-table" className="table" style={{width:"100%"}}>
                                  <thead>
                                      <tr>
                                          <th className="text-center">{LBL_TYPE}</th>
                                          <th className="text-center">{LBL_DESCRIPTION}</th>
                                          <th className="text-center">{LBL_AMOUNT} ({profileCurrency})</th>
                                          <th className="text-center">{LBL_REMOVE}</th>
                                      </tr>
                                  </thead>                                    
                                  <tbody id="amountTable">
                                    {tableRows.length === 0 && 
                                        <tr>
                                            <td colSpan="4" className="text-center">{MSG_NOT_FOUND}</td>
                                        </tr>
                                    } 
                                    {tableRows.length>0 && tableRows.map((item,index) =>{
                                        return (
                                                <tr key={item.key} >
                                                    <td className="text-center">
                                                        <div className="form-group select-input">
                                                            <select name={"type_"+item.key} onChange={(e) => this.onHandleChange(e,item.key)} value={item.type}>
                                                                <option value='expense'>{LBL_EXPENSE}</option>
                                                                <option value='discount'>{LBL_DISCOUNT}</option>
                                                                
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="text-input form-group" >
                                                            <input type="text" className={Object.keys(this.state.formError).length !== 0?this.state.formError[item.key].description+ " min-width-400":"min-width-400"} name={"description_"+item.key} onChange={(e) => this.onHandleChange(e,item.key)} value={item.description} maxLength="500"/>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="text-input form-group" >
                                                            <input type="text" onFocus={this.handleFocus} className={"max-width-100 input-text-right"+ Object.keys(this.state.formError).length !== 0?this.state.formError[item.key].amount +' max-width-100 input-text-right':' max-width-100 input-text-right'} name={"amount_"+item.key} onChange={(e) => this.onHandleChange(e,item.key)} value={item.amount} onBlur={(e) =>this.onHandleBlur(e,item.key)}/>
                                                        </div> 
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="deleteIcon" onClick={(e)=>this.removeRow(e,item.key)}><i className="las la-trash-alt"></i></span>
                                                    </td>
                                                </tr>    
                                        )
                                    })}
                                         
                                    </tbody>
                                 </table>
                           </div>                            
                        </div>}
 
                        {this.props.isAddEvent && this.props.isClientPage===false &&<p className="marginTop10">
                            <button type="button" className="btn btn-primary float-right" id="regenerateInvoice" name="regenerateInvoice" onClick={(e) => this.regenerateInvoice(e)} >{LBL_REGEN_INVOICE}</button>
                        </p>} 
                        <p>
                        </p>
                        {this.state.listInvoice && this.state.listInvoice.void_invoices && this.state.listInvoice.void_invoices.length > 0 && 
                        <div className="col-12 add-new-btn-div"><label>{LBL_VOID_INVOICE}</label></div>}
                        {this.state.listInvoice && this.state.listInvoice.void_invoices && this.state.listInvoice.void_invoices.length > 0 && 
                        <div className="box-content">
                           <div className="table-responsive">
                              <table id="data-table" className="table" style={{width:"100%"}}>
                                  <thead>
                                      <tr>
                                          <th className="text-center">{LBL_CN_NO}/{LBL_INVOICE_ID}</th>
                                          <th className="text-center">{LBL_CREATED_ON}</th>
                                          <th className="text-center">{LBL_VOID_ON}</th>
                                          <th className="text-center">{LBL_AMOUNT} ({profileCurrency})</th>
                                      </tr>
                                  </thead>                                    
                                  <tbody> 
                                  { this.state.listInvoice && this.state.listInvoice.void_invoices && this.state.listInvoice.void_invoices.length === 0 && 
                                        <tr>
                                            <td colSpan="4" className="text-center">{MSG_NOT_FOUND}</td>
                                        </tr>
                                  }
                                  { this.state.listInvoice && this.state.listInvoice.void_invoices && this.state.listInvoice.void_invoices.length>0 &&
                                    this.state.listInvoice.void_invoices.map((item,index) =>{
                                        return (
                                            <tr>
                                                <td className="text-center">
                                                    <Link to="#" onClick={(e) => this.showInvoicePreview(item.invoice_file)}><b>{item.invoice_number}</b></Link>
                                                </td>
                                                <td className="text-center">
                                                    {converDateToLocal(item.created_on,"+00:00",'ddmmyyyyhhmm')}
                                                </td>
                                                <td className="text-center">
                                                    {converDateToLocal(item.modified_on,"+00:00",'ddmmyyyyhhmm')}
                                                </td>
                                                <td className="text-center">
                                                    {parseFloat(item.total).toFixed(2)}
                                                </td>
                                            </tr>
                                        )
                                    })
                                    
                                  }
                                             
                                    </tbody>
                                 </table>
                           </div>                            
                        </div>}
                    </Scrollbars>
                </div>
                <PreviewInvoice ref={this.previewQuote} sendOldInvoice={this.sendOldInvoice} eventPreviewQuote={invoiceQuote} profileCurrency={profileCurrency} additionalValues={this.state.tableRows} saveFormData={this.saveFormData}>
                </PreviewInvoice>
            </React.Fragment> 
        )
    }
}

const mapStateToProps = (state) => {
    return {
        invoiceList:state.event.invoiceList,
        status:state.event.status,
        invoiceActivity:state.event.invoiceActivity,
        invoiceQuote:state.event.invoiceQuote
    }
}           

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        listInvoiceAction:listInvoiceAction,
        updateInvoiceAction:updateInvoiceAction,
        invoicePreviewAction:invoicePreviewAction,
        invoiceSendtoClientAction:invoiceSendtoClientAction
    },dispatch);
} 
export default connect(mapStateToProps,mapDispatchToProps)(InvoiceComponent);

        